(function() { module.exports = this["wc"]["wcSettings"]; }());